import { Alert, CircularProgress, FormControlLabel, Checkbox, Modal, Snackbar, Box, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useForm, Controller, FormProvider } from "react-hook-form";
import useStateRef from "react-usestateref";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { Geral } from "./Abas/Geral";
import { Pontos } from "./Abas/Pontos";
import { Documentos } from "./Abas/Documentos";
import { useDispatch, useSelector } from "react-redux";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { defaultValues, schema } from "./ValidacoesSolCompart";
import { validarCpf } from '../../../infra/utils/ValidacaoCpf';
import { ptBR } from "date-fns/locale";
import { parse, format } from "date-fns";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackward } from "@fortawesome/free-solid-svg-icons";

import servSolicitacaoCompartilhamento from "../../../services/login/servSolicitacaoCompartilhamento";
import servSolicitacaoCompartilhamentoDocs from "../../../services/login/servSolicitacaoCompartilhamentoDocs";
import servParam from "../../../services/login/servParam";

import styles from "./Cadastro.module.css";
import { logout } from "../../../state/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import Ocupante from "../../Ocupante";
import servConsultaDisponibilidade from "../../../services/login/servConsultaDisponibilidade";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Cadastro = ({ setOpenPopup, recordForEdit, addOrEdit, pesquisar, origemSolicitacao, origemListaEquipamentosSolicitacao = false }) => {
    const methods = useForm({ mode: "onBlur", defaultValues: defaultValues, resolver: yupResolver(schema) });
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState(0);

    const [podeSalvar, setPodeSalvar] = useState(true);
    const [campoQtdeObrig, setCampoQtdeObrig] = useState(false);
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [disableUpload, setDisableUpload] = useState(false);
    const [disableCampos, setDisableCampos] = useState(false);
    const [fazFiscalizacao, setFazFiscalizacao] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [fecharAoSalvar, setFecharAoSalvar, fecharAoSalvarRef] = useStateRef(true);
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);
    const [disableAba, setDisableAba] = useState(null);
    const [cpfInvalido, setCpfInvalido] = useState(null);

    const [required, setRequired] = useState(false);
    const [situacao, setSituacao] = useState(0);
    const [desabilitaHomologacao, setDesabilitaHomologacao] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpen(false);
        }

        setOpen(false);
    }

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenSuccess(false);
        }

        setOpenSuccess(false);
    }

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDialog(false);
        }

        setOpenDialog(false);
    }


    useEffect(() => {
        const situacoesBloqueadas = [1, 3, 4, 5, 6, 7, 8];

        if (recordForEdit !== null) {

            const recuperarDados = async () => {
                try {
                    setIsLoading(true);

                    let data = await servSolicitacaoCompartilhamento.RecuperarParaEditar(recordForEdit?.id || recordForEdit?.Id);
                    mapearCamposDaEdicao(data.Content);
                    setSituacao(data.Content.Situacao)

                    setIsLoading(false);

                } catch (err) {
                    setIsLoading(false);

                    if (err?.response?.status === 401) {
                        setErrorMessage("Token expirado, redirecionando...");
                        setOpen(true);
                        return setTimeout(() => {
                            dispatch(logout());
                            navigate("/");
                        }, [2000]);
                    }

                    setErrorMessage(err?.response?.data?.Message);
                    setOpen(true);
                }
            }

            recuperarDados();
            recuperarDocumentosIniciais();

            if (situacoesBloqueadas.includes(recordForEdit?.Situacao)) {
                setPodeSalvar(false);
                setDisableUpload(true);
                setDisableCampos(true);
            }
        }
    }, [recordForEdit]);

    const proximaAba = async () => {
        const situacaoNaoEditaveis = [1, 3, 4, 5, 6, 7, 8];

        if (disableAba) return;

        if ((methods.getValues("qtdePontos") === 0 || !methods.getValues("qtdePontos")) && !exibirAbaPontos) {
            setCampoQtdeObrig(true);
            return;
        }

        if (!validarCpf(methods.getValues("cpfRepresentante"))) {
            setCpfInvalido(true);
            setErrorMessage("CPF inválido.");
            setOpen(true);
            return;
        }

        if (situacaoNaoEditaveis.includes(methods.getValues("situacao"))) {
            setDesabilitaHomologacao(true);
            if (tabIndex === 2 || (tabIndex === 1 && !exibirAbaPontos)) {
                return setTabIndex(0)
            } else {
                setTabIndex(tabIndex + 1);
            }

            return;
        }

        setFecharAoSalvar(false)
        await handleCadastroSolCompartilhamento();
        setFecharAoSalvar(true);

        if (methods.getValues("Id") == 0 || methods.getValues("Id") == null || methods.getValues("Id") == undefined || tabIndex === 0) {
            if (Object.keys(methods.formState.errors).length > 0) {
                var errors = methods.formState.errors;

                if (errors.nome || errors.inscricao) {
                    setTabIndex(0);
                    return;
                }
            }
        } else {
            let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

            if (houveAlteracaoCampos) {
                if (Object.keys(methods.formState.errors).length > 0) {
                    return;
                }
            }

            if (tabIndex === 1) {
                recuperarDocumentosIniciais();
            }
        }

        if (tabIndex === 0 && !methods.getValues("Id")) {
            setTabIndex(0);
            return;
        }

        if (tabIndex === 2 || (tabIndex === 1 && !exibirAbaPontos)) {
            return setTabIndex(0);
        }

        setTabIndex(tabIndex + 1);
    }

    const recuperarDocumentosIniciais = async () => {
        try {
            setIsLoading(true);

            const idSolCompart = recordForEdit ? recordForEdit?.id || recordForEdit?.Id : methods.getValues("Id");

            const [docsObrigatorios, docsVinculados] = await Promise.all([
                servParam.RecuperarDocumentosObrigatorios(12),
                servSolicitacaoCompartilhamentoDocs.listar(idSolCompart)
            ]);

            const docsAtualizados = mapearCamposDaEdicaoDocs(docsObrigatorios.Content, docsVinculados.Content);

            setIsLoading(false);

            return docsAtualizados;

        } catch (err) {
            setIsLoading(false);

            if (err?.response?.status === 401) {
                setErrorMessage("Token expirado, redirecionando...");
                setOpen(true);
                return setTimeout(() => {
                    dispatch(logout());
                    navigate("/");
                }, [2000]);
            }

            setErrorMessage(err?.response?.data?.Message);
            setOpen(true);
        }
    }

    const mapearCamposDaEdicaoDocs = (docsObrigatorios, docsVinculados) => {
        const docsAtualizados = docsObrigatorios.map((doc) => {
            const documentoVinculado = docsVinculados?.find(
                (docVinculado) =>
                    doc.Id == docVinculado.CodigoConfiguracaoDoc &&
                    doc.CodigoClassificacaoDoc == docVinculado.CodigoClassificacaoDoc
            );

            if (documentoVinculado) {
                return {
                    ...doc,
                    CodigoOcupanteDoc: documentoVinculado.Id,
                    CodigoDocumento: documentoVinculado.CodigoDocumento,
                    NomeArquivo: documentoVinculado.NomeArquivo,
                    Aprovado: documentoVinculado.Aprovado
                };
            }

            return doc;
        });

        setDocumentosObrigatorios(docsAtualizados);

        return docsAtualizados;
    };

    const mapearCamposDaEdicao = (data) => {
        delete data.Cidades.UF;

        methods.setValue("Id", data.Id);
        methods.setValue("Protocolo", data.Protocolo);
        methods.setValue("codigoVisual", data.CodigoVisual);
        methods.setValue("analise", data.Analise);
        methods.setValue("bairro", data.Bairro);
        methods.setValue("cpfRepresentante", data.CpfRepresentante);
        methods.setValue("dataApresentacao", parse(data.DataApresentacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("dataAprovacao", parse(data.DataAprovacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("dataCadastro", parse(data.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("dataInicioInstalacao", parse(data.DataInicioInstalacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("dataTerminoInstalacao", parse(data.DataTerminoInstalacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("emailRepresentante", data.EmailRepresentante);
        methods.setValue("motivoReprovacao", data.MotivoReprovacao);
        methods.setValue("nomeRepresentante", data.NomeRepresentante);
        methods.setValue("prazoAnalise", parse(data.PrazoAnalise, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("prazoAvisoInstalacao", parse(data.PrazoAvisoInstalacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("qtdePontos", data.QtdePontos);
        methods.setValue("situacao", data.Situacao);

        const formatarCNPJ = (inscricao) => {
            if (!inscricao) return '';

            const numeros = inscricao.replace(/\D/g, '');

            return numeros.replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                '$1.$2.$3/$4-$5'
            );
        };

        const inscricaoFormatada = formatarCNPJ(data.Ocupante.Inscricao);

        if (data.TipoCabo) {
            methods.setValue("tipoCabo", {
                value: data.TipoCabo,
                label: data.TipoCabo === 1 ? "Metálico" : "Óptico"
            });

            methods.setValue("Ocupante", data.Ocupante);
        }

        if (data.CodigoOcupante) {
            methods.setValue("codigoOcupante", {
                value: data.Ocupante.Id,
                label: `${inscricaoFormatada} - ${data.Ocupante.Nome}`,
                CodigoUsoMutuo: data.Ocupante.CodigoUsoMutuo
            });

            methods.setValue("Ocupante", data.Ocupante);
        }

        if (data.CodigoCidade) {
            methods.setValue("codigoCidade", {
                value: data.Cidades.Id,
                label: data.Cidades.Nome
            });

            methods.setValue("Cidades", data.Cidades);
        }

        if (data.CodigoBairro) {
            methods.setValue("codigoBairro", {
                value: data.Bairros.Id,
                label: data.Bairros.Nome,
                codigoRegiao: data?.CodigoRegiao
            });

            methods.setValue('Bairros', data.Bairros);
        }

        methods.setValue('codigoRegiao', data?.CodigoRegiao);
    };

    const handleClickOpenDialog = async (event, reason) => {
        try {
            setFecharAoSalvar(false);
            await handleCadastroSolCompartilhamento();
            setFecharAoSalvar(true);

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            const docsAtualizados = await recuperarDocumentosIniciais();

            const docsObrigatoriosPendentes = (docsAtualizados ?? documentosObrigatorios).filter(
                doc => doc.Obrigatorio === 1 && !doc.CodigoDocumento
            );

            if (docsObrigatoriosPendentes.length > 0) {
                const nomesDocs = docsObrigatoriosPendentes.map(doc => doc.Descricao).join(', ');
                setErrorMessage(`Existem documentos obrigatórios pendentes: ${nomesDocs}`);
                setOpen(true);
                return;
            }

            await enviar(true);
        } catch (err) {
            setOpen(false);
            return setErrorMessage(err?.response?.data?.Message);
        }
    }

    const handleCadastroSolCompartilhamento = methods.handleSubmit(async (data) => {
        if (!validarCpf(methods.getValues("cpfRepresentante"))) {
            setCpfInvalido(true);
            setErrorMessage("CPF inválido.");
            setOpen(true);
            return;
        }

        data.cpfRepresentante = data.cpfRepresentante.replace(/\D/g, "");

        try {

            const solCompartilhamento = {
                Id: data.Id,
                Analise: data.analise,
                CodigoCidade: data.codigoCidade?.value,
                Cidades: data.codigoCidade,
                Bairros: data.codigoBairro,
                CodigoOcupante: !data.codigoOcupante?.value ? null : data.codigoOcupante?.value,
                Ocupante: data.codigoOcupante,
                DataInicioInstalacao: data.dataInicioInstalacao,
                DataTerminoInstalacao: data.dataTerminoInstalacao,
                PrazoAnalise: data.prazoAnalise,
                PrazoAvisoInstalacao: data.prazoAvisoInstalacao,
                CpfRepresentante: data.cpfRepresentante,
                EmailRepresentante: data.emailRepresentante,
                NomeRepresentante: data.nomeRepresentante,
                QtdePontos: data.qtdePontos,
                Situacao: data.situacao,
                TipoCabo: !data.tipoCabo?.value ? null : data.tipoCabo?.value,
                CodigoBairro: data.codigoBairro?.value,
                CodigoRegiao: data.codigoBairro?.codigoRegiao
            }

            setIsLoading(true);

            let response = await adicionarOuEditar(solCompartilhamento);
            if (!response) {
                setIsLoading(false);
                return;
            }

            methods.setValue("Id", response.id);
            methods.setValue("codigoVisual", response.codigoVisual);
            methods.setValue("analise", response.analise);
            methods.reset({}, { keepValues: true });
            recuperarDocumentosIniciais();

            setIsLoading(false);

            setOpenSuccess(true);
            setSuccessMessage("Sol. Compartilhamento salva com sucesso.");

            if (fecharAoSalvarRef.current) {
                setTimeout(() => {
                    setOpenPopup(false);
                }, [1000]);
            }

            pesquisar();
        } catch (err) {
            setIsLoading(false);
            setOpen(true);
            return setErrorMessage(err?.response?.data?.Message);
        }
    });

    const adicionarOuEditar = async (solCompartilhamento) => {
        try {
            let id;
            let codigoVisual;
            let analise;

            solCompartilhamento.CodigoResponsavelTecnico = user.codigoUsuario;

            if (!solCompartilhamento.Id) {
                const response = await servSolicitacaoCompartilhamento.inserir(
                    solCompartilhamento.Situacao,
                    solCompartilhamento.CodigoResponsavelTecnico,
                    solCompartilhamento.CodigoOcupante,
                    solCompartilhamento.CodigoCidade,
                    solCompartilhamento.Bairro,
                    solCompartilhamento.TipoCabo,
                    solCompartilhamento.NomeRepresentante,
                    solCompartilhamento.CpfRepresentante,
                    solCompartilhamento.EmailRepresentante,
                    solCompartilhamento.QtdePontos,
                    solCompartilhamento.CodigoBairro,
                    solCompartilhamento.CodigoRegiao
                );

                id = response.Content.Id;
                analise = response.Content.Analise;
                codigoVisual = response.Content.CodigoVisual;
            } else {
                const response = await servSolicitacaoCompartilhamento.editar(
                    solCompartilhamento.Id,
                    solCompartilhamento.Analise,
                    solCompartilhamento.Situacao,
                    solCompartilhamento.CodigoResponsavelTecnico,
                    solCompartilhamento.CodigoOcupante,
                    solCompartilhamento.CodigoCidade,
                    solCompartilhamento.Bairro,
                    solCompartilhamento.TipoCabo,
                    solCompartilhamento.NomeRepresentante,
                    solCompartilhamento.CpfRepresentante,
                    solCompartilhamento.EmailRepresentante,
                    solCompartilhamento.DataInicioInstalacao,
                    solCompartilhamento.QtdePontos,
                    solCompartilhamento.CodigoBairro,
                    solCompartilhamento.CodigoRegiao
                );

                id = response.Content.Id;
                analise = response.Content.Analise;
                codigoVisual = response.Content.CodigoVisual;
            }

            return { id, codigoVisual, analise };
        } catch (err) {
            setOpen(true);
            return setErrorMessage(err?.response?.data?.Message);
        }
    };

    const handleTabChange = async (event, newValue) => {
        const situacoesNaoEditaveis = [1, 3, 4];

        if ((methods.getValues("qtdePontos") === 0 || !methods.getValues("qtdePontos")) && !exibirAbaPontos) {
            setCampoQtdeObrig(true);
            return;
        }

        if (!validarCpf(methods.getValues("cpfRepresentante"))) {
            setCpfInvalido(true);
            setErrorMessage("CPF inválido.");
            setOpen(true);
            return;
        }

        if (situacoesNaoEditaveis.includes(methods.getValues("situacao"))) {
            setTabIndex(newValue);
            return;
        }

        setFecharAoSalvar(false);
        await handleCadastroSolCompartilhamento();
        setFecharAoSalvar(true);

        if ((methods.getValues("Id") == 0 || methods.getValues("Id") == null || methods.getValues("Id") == undefined) || tabIndex === 0) {
            if (Object.keys(methods.formState.errors).length > 0) {
                var errors = methods.formState.errors;

                if (errors) {
                    setTabIndex(0);
                    return;
                }

            }
            if (newValue === 1 && !methods.getValues("Id")) {
                setTabIndex(0);
                return;
            }

            setTabIndex(newValue);
        } else {
            let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

            if (houveAlteracaoCampos) {
                if (Object.keys(methods.formState.errors).length > 0) {
                    return;
                }
            }

            recuperarDocumentosIniciais();

            setTabIndex(newValue);
        }
    }

    const [exibirAbaPontos, setExibirAbaPontos] = useState(true);

    useEffect(() => {
        const verificarExibicaoAbaPontos = async () => {
            try {
                const params = await servSolicitacaoCompartilhamento.BuscarParametros();
                const paramsCI = await servParam.recuperarCIParametros();

                if (params && params.Content && params.Content.length) {
                    setFazFiscalizacao(Boolean(params.Content[0]?.FazFiscalizacao));
                } else {
                    setFazFiscalizacao(Boolean(params.Content[0]?.FazFiscalizacao));
                }

                if (paramsCI && paramsCI.Content && paramsCI.Content.length) {
                    setExibirAbaPontos(Boolean(paramsCI.Content.DisponibilizaMapas) && paramsCI.Content.ChaveGoogle);
                } else {
                    setExibirAbaPontos(Boolean(paramsCI.Content.DisponibilizaMapas) && paramsCI.Content.ChaveGoogle);
                }
            } catch {
                setExibirAbaPontos(true);
                setFazFiscalizacao(true);
            }
        };
        verificarExibicaoAbaPontos();
    }, []);

    const enviar = async () => {
        try {
            const dto = {
                id: recordForEdit?.row?.Id || recordForEdit?.Id || methods.getValues("Id")
            };

            await servSolicitacaoCompartilhamento.SolicitarAnalise(dto);
            pesquisar();
            handleCloseDialog();

            if (fecharAoSalvarRef.current) {
                setTimeout(() => {
                    setOpenPopup(false);
                }, [600]);
            }
        } catch (error) {
            setTimeout(() => {
                setOpen(true);
                setErrorMessage(error?.response?.data?.Message || "Erro ao solicitar análise.");
            }, [600]);
        }
    };

    function isDefaultDate(date) {
        if (!date) return true;

        if (typeof date === "string") {
            return date.includes("01/01/1900") || date.includes("01/01/0001");
        }

        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();

        return (
            (year === 1900 && month === 0 && day === 1) ||
            (year === 1 && month === 0 && day === 1)
        );
    }

    return (
        <div className={styles['modal-main']}>
            {tabIndex === 0 && <div style={{ paddingBottom: "10px" }}>
                {methods.getValues("Id") && <div>
                    <header className={styles.header} style={{ borderBottom: "1px solid #b8b8b8" }}>
                        {((fazFiscalizacao && !isDefaultDate(methods.getValues("dataInicioInstalacao"))) && <span className={styles.headerData}>
                            <div className={styles.dateBox}></div>
                            <b>Data início instalação: </b>
                            {!methods.getValues("dataInicioInstalacao") ||
                                isDefaultDate(methods.getValues("dataInicioInstalacao"))
                                ? "Data ainda não definida"
                                : format(
                                    methods.getValues("dataInicioInstalacao"),
                                    "dd/MM/yyyy",
                                    {
                                        locale: ptBR,
                                    }
                                )}
                        </span>)}

                        {((fazFiscalizacao && !isDefaultDate(methods.getValues("dataTerminoInstalacao"))) && <span className={styles.headerData}>
                            <div
                                className={`${styles.dateBox} ${styles["dateBox-green"]}`}
                            ></div>
                            <b>Data término instalação: </b>
                            {!methods.getValues("dataTerminoInstalacao") ||
                                isDefaultDate(methods.getValues("dataTerminoInstalacao"))
                                ? "Data ainda não definida"
                                : format(
                                    methods.getValues("dataTerminoInstalacao"),
                                    "dd/MM/yyyy",
                                    {
                                        locale: ptBR,
                                    }
                                )}
                        </span>)}
                    </header>
                    <header className={styles.header} style={{ borderBottom: "1px solid #b8b8b8" }}>
                        {((fazFiscalizacao && !isDefaultDate(methods.getValues("prazoAvisoInstalacao"))) && <span className={styles.headerData}>
                            <div
                                className={`${styles.dateBox} ${styles["dateBox-darkblue"]}`}
                            ></div>
                            <b>Prazo aviso de instalação: </b>
                            {!methods.getValues("prazoAvisoInstalacao") ||
                                isDefaultDate(methods.getValues("prazoAvisoInstalacao"))
                                ? "Data ainda não definida"
                                : format(
                                    methods.getValues("prazoAvisoInstalacao"),
                                    "dd/MM/yyyy",
                                    {
                                        locale: ptBR,
                                    }
                                )}
                        </span>)}

                        {(!isDefaultDate(methods.getValues("prazoAnalise")) && <span className={styles.headerData}>
                            <div
                                className={`${styles.dateBox} ${styles["dateBox-orange"]}`}
                            ></div>
                            <b>Prazo análise: </b>
                            {!methods.getValues("prazoAnalise") ||
                                isDefaultDate(methods.getValues("prazoAnalise"))
                                ? "Data ainda não definida"
                                : format(
                                    methods.getValues("prazoAnalise"),
                                    "dd/MM/yyyy",
                                    {
                                        locale: ptBR,
                                    }
                                )}
                        </span>)}
                        {!!methods.getValues("Protocolo") && (<span className={styles.headerData}>
                            <div
                                className={`${styles.dateBox} ${styles["dateBox-gray"]}`}
                            ></div>
                            <><b>Protocolo:</b> {methods.getValues("Protocolo")}</>
                        </span>)}
                    </header>
                </div>}
            </div>}
            <FormProvider {...methods}>
                <form onSubmit={handleCadastroSolCompartilhamento}>
                    <div className={styles.class100E}>
                        <div className={styles.tabsEHeader}>
                            <Tabs value={tabIndex} sx={{ width: "95%" }} onChange={handleTabChange} aria-label="abas cadastro de sol. compartilhamento">
                                <Tab sx={{ color: "whitesmoke" }} label="Geral" {...a11yProps(0)} />
                                {exibirAbaPontos && <Tab sx={{ color: "whitesmoke" }} label="Pontos" {...a11yProps(1)} />}
                                <Tab sx={{ color: "whitesmoke" }} label="Documentos" {...a11yProps(exibirAbaPontos ? 2 : 1)} />
                            </Tabs>
                        </div>
                        <TabPanel value={tabIndex} index={0}>
                            <Geral
                                disableCampos={disableCampos}
                                setOpen={setOpen}
                                setDisableAba={setDisableAba}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                setPodeSalvar={setPodeSalvar}
                                recordForEdit={recordForEdit}
                                methods={methods}
                                onKeyDown={methods.handleKeyDown}
                                situacao={situacao}
                                fazFiscalizacao={fazFiscalizacao}
                                exibirAbaPontos={exibirAbaPontos}
                                cpfInvalido={cpfInvalido}
                                setCpfInvalido={setCpfInvalido}
                                campoQtdeObrig={campoQtdeObrig}
                                setCampoQtdeObrig={setCampoQtdeObrig}
                            />
                        </TabPanel>

                        {(exibirAbaPontos && <TabPanel value={tabIndex} index={1}>
                            <Pontos
                                disableCampos={disableCampos}
                                setOpen={setOpen}
                                setDisableAba={setDisableAba}
                                setErrorMessage={setErrorMessage}
                                setPodeSalvar={setPodeSalvar}
                                situacao={situacao}
                                methods={methods}
                                setOpenSuccess={setOpenSuccess}
                                setSuccessMessage={setSuccessMessage}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                solicitacaoCompartilhamento={recordForEdit ? recordForEdit.Id || recordForEdit.id : methods.getValues("Id")}
                                onKeyDown={methods.handleKeyDown}
                            />
                        </TabPanel>)}
                        <TabPanel value={tabIndex} index={exibirAbaPontos ? 2 : 1}>
                            <Documentos
                                documentos={documentosObrigatorios}
                                setOpenError={setOpenError}
                                setErrorMessage={setErrorMessage}
                                setIsLoading={setIsLoading}
                                codigoSolCompartilhamento={recordForEdit ? recordForEdit?.id || recordForEdit?.Id : methods.getValues("Id")}
                                situacaoSolic={situacao}
                            />
                        </TabPanel>
                    </div>
                    <div className={styles.cadastro_sol_compartilhamento_botoes}>
                        <BlueHoverButton type="submit" id="salvarSolCompartilhamento" name="salvarSolCompartilhamento" disabled={!podeSalvar}>
                            Salvar
                        </BlueHoverButton>
                        <BlueHoverButton onClick={proximaAba} disabled={!podeSalvar}>
                            {tabIndex == 0 && exibirAbaPontos ? (
                                <div>Informar Pontos</div>
                            ) : (tabIndex == 1 && exibirAbaPontos) || (tabIndex == 0 && !exibirAbaPontos) ? (
                                <div>Informar documentos</div>
                            ) : (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <FontAwesomeIcon icon={faBackward} style={{ paddingRight: "10px", fontSize: "16px" }} />
                                    <div>Revisar dados gerais</div>
                                </div>
                            )}
                        </BlueHoverButton>
                        {((tabIndex == 2 && exibirAbaPontos) || (tabIndex == 1 && !exibirAbaPontos)) && (
                            <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar}>
                                Solicitar análise
                            </BlueHoverButton>
                        )}
                        <BlueHoverButton onClick={() => setOpenPopup(false)}>
                            Cancelar
                        </BlueHoverButton>
                    </div>
                </form>
            </FormProvider>
            <Snackbar open={openSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={2000} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                    {successMessage}
                </Alert>
            </Snackbar>
            <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { Cadastro }
